/**
 * Converts a File object to a base64-encoded string.
 *
 * @param {File} file - The File object to convert.
 * @returns {Promise<string>} A promise that resolves with the base64-encoded string.
 */
export const convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
};

/**
 * Converts a Blob URL to a File object.
 *
 * @param {string} blobUrl - The Blob URL to convert.
 * @returns {Promise<File>} A promise that resolves with the resulting File object.
 */
export const convertBlobUrlToFile = async (blobUrl) => {
    const response = await fetch(blobUrl);
    const blob = await response.blob();
    return new File([blob], blobUrl.split('/').pop(), { type: blob.type });
};
